import { defineComponent, onMounted, reactive } from 'vue';
import { onBeforeRouteUpdate, useRoute } from 'vue-router';
import { useMenuStore } from '@/stores/menu';
import { onClickMenu, traversalMenus } from '@/utils/router';
import navs from '@/router/raws/nav';
export default defineComponent({
  setup() {
    const menu = useMenuStore();
    const route = useRoute();
    const state = reactive({
      defaultActive: ''
    });

    // 激活当前路由的菜单
    const currentRouteActive = currentRoute => {
      state.defaultActive = currentRoute.path;
    };
    onMounted(() => {
      const menus = traversalMenus(navs);
      menu.setNavs(menus);
      currentRouteActive(route);
    });
    onBeforeRouteUpdate(to => {
      currentRouteActive(to);
    });
    return {
      state,
      menu,
      onClickMenu
    };
  }
});